import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

export const priceMonitorRouter: RouteRecordRaw[] = [
    {
        path: "/priceMonitor",
        name: "PriceMonitor",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/priceMonitor/commodityIndex",
        meta: {
            title: "价格监控",
            icon: "icon-jiagejiankong"
        },
        children: [
            {
                path: "/priceMonitor/commodityIndex",
                name: "CommodityIndex",
                component: () => import("@/views/pages/priceMonitor/commodityIndex/index.vue"),
                meta: {
                    title: "大宗商品指数",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/priceMonitor/rateIndex",
                name: "RateIndex",
                component: () => import("@/views/pages/priceMonitor/rateIndex/index.vue"),
                meta: {
                    title: "运价指数",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            }
        ]
    }
];

export default priceMonitorRouter;
